import React from "react";
import { SelectAreaModalProps, UseSelectAreaModalProps } from "./types";
import { useSelectArea } from "./useSelectArea";
import SelectAreaModalView from "./SelectAreaModalView";

function SelectAreaModal(props: SelectAreaModalProps) {
  const hook: UseSelectAreaModalProps = useSelectArea(props);

  return <SelectAreaModalView props={props} hook={hook} />;
}
export default React.memo(SelectAreaModal);
